import { RESET_FORM } from '../actionTypes';
import { createAttachmentModalActions } from '../reducer';

export default () => createAttachmentModalActions[RESET_FORM]();
